export default "__VITE_ASSET__IyL6qu2T__"